export enum PermissionsEnum {
	CREATE_VIDEO = 0,
	EDIT_VIDEO = 1,
	DELETE_VIDEO = 2,
	VIEW_VIDEO = 3,
	CREATE_CATEGORY = 4,
	EDIT_CATEGORY = 5,
	DELETE_CATEGORY = 6,
	VIEW_CATEGORY = 7,
	CREATE_COURSE = 8,
	EDIT_COURSE = 9,
	DELETE_COURSE = 10,
	VIEW_COURSE = 11,
	CREATE_STUDENT = 12,
	EDIT_STUDENT = 13,
	DELETE_STUDENT = 14,
	VIEW_STUDENT = 15,
	CREATE_CLIENT = 16,
	EDIT_CLIENT = 17,
	DELETE_CLIENT = 18,
	VIEW_CLIENT = 19,
	VIEW_NOTE = 20,
	EDIT_NOTE = 21,
	DELETE_NOTE = 22,
	CREATE_NOTE = 23,
	VIEW_ASSIGNED_CATEGORIES = 24,
	VIEW_FAVORITES = 25,
	VIEW_MY_COURSES = 26,
	VIEW_WEBHOOKS = 27,
	RESEND_WEBHOOK = 28,
	MARKETPLACE = 29,
	REGISTER = 30,
	LEARNING_PLATFORM = 31,
	CREATE_PERMISSIONS = 32,
	EDIT_PERMISSIONS = 33,
	VIEW_PERMISSIONS = 34,
	VIEW_ACCOUNT_SETTINGS = 35,
	VIEW_ACCOUNT_SETTINGS_PASSWORD = 36,
	VIEW_ACCOUNT_SETTINGS_PAYMENT_METHODS = 37,
	VIEW_ACCOUNT_SETTINGS_PURCHASE_HISTORY = 38,
	EXPORT_STUDENTS_CSV = 39,
	FILTER_STUDENTS_DATE = 40,
	VIEW_STUDENTS_AMOUNT = 41,
	VIEW_ROLES = 42,
	EDIT_ROLES = 43,
	VIEW_EXPLORE = 44,
	VIEW_HOME = 45,
	VIEW_SALES = 46,
	CATEGORY_FORM_ASSIGN_CLIENTS = 47,
	CATEGORY_FORM_ASSIGN_PRICE = 48,
	CATEGORY_FORM_PROMOTIONAL_VIDEO = 49,
	VIEW_SHOPPING_CART = 50,
	VIEW_HEADER_CLIENT_NAME = 51,
	VIEW_FOOTER = 52,
	VIEW_HEADER = 53,
	VIEW_ORDER = 54,
	VIEW_TERMS_AND_CONDITIONS = 55,
	VIEW_PRIVACY_POLICY = 56,
	VIEW_COOKIE_NOTICE = 57,
	VIEW_REFUND_AND_DELIVERY_POLICY = 58,
	ALLOW_VIDEO_FAST_FORWARD = 59,
	VIEW_ASSIGNED_COURSES = 60,
	VIEW_ASSIGNED_FILES = 61,
	VIEW_TAWKTO_SUPPORT = 62,
	LANGUAGE_SWITCHER_ON_USER_OPTIONS = 63,
	LANGUAGE_SWITCHER_ON_HEADER = 64,
	SHOW_HAMBURGUER_MENU = 65,
	VIEW_REPORTS = 66,
	ALLOW_CONTENT_QUESTIONS = 67,
	ALLOW_CONTACT_AGENCY = 68,
	VIEW_CHATBOT_MESSAGES = 69,
	VIEW_ONLINE_USERS = 70
}
